import { SystemBanner } from '@shinetools/lumen-react'
import { Trans, useTranslation } from 'react-i18next'

import { BulletUnorderedList } from './styles'

export const EInvoicingDocumentUploadInfoBanner = () => {
  const { t } = useTranslation()

  return (
    <SystemBanner
      type="info"
      // @ts-expect-error forcing a div
      message={
        <div>
          <b>{t('e_invoice.kyc.step.upload.banner_title')}</b>
          <BulletUnorderedList>
            <Trans
              i18nKey="e_invoice.kyc.step.upload.banner_steps"
              components={{
                li: <li />,
              }}
            />
          </BulletUnorderedList>
        </div>
      }
    />
  )
}
